export enum RouteName {
    DEFAULT_ORGANISATION_ID = 'oid',
    HOME = 'home',
    APP = 'app',
    APP_ID = 'app_id',//Marketplace app
    APP_NAME = 'app_name',//Marketplace app
    CONTACT_ID = 'contact_id',
    WORKFLOW_ID = 'workflow_id',
    DEAL_ID = 'deal_id',
    PRODUCT_ID = 'product_id',
    COMPANY_ID = 'company_id',
    BROADCAST_ID = 'broadcast_id',
    LOGIN = 'login',
    LOGOUT = 'logout',
    CREATE_ACCOUNT = 'create-account',
    ACCOUNT_CREATED = 'account-created',
    FORGOT_PASSWORD = 'forgot-password',
    CONTACTS = 'contacts',
    CONTACT = 'contact',
    AUTH = 'auth',
    OAUTH = 'oauth',
    AUTHORIZE = 'authorize',
    FIELDS = 'fields',
    DEALS = 'deals',
    DEAL = 'deal',
    TASKS = 'tasks',
    PRODUCTS = 'products',
    PRODUCT = 'product',
    COMPANY = 'company',
    COMPANIES = 'companies',
    CALLS = 'calls',
    BROADCASTS = 'broadcasts',
    BROADCAST = 'broadcast',
    REPORTS = 'reports',
    SEARCH = 'search',
    AUTOMATIONS = 'automations',
    WORKFLOW = 'workflow',
    MARKETPLACE = 'marketplace',
    HELP = 'help',
    SETTINGS = 'settings',
    ORGANISATIONS = 'organisations',
    SELECT = 'select',
    CREATE = 'create',
    LIST = 'list',
    JOIN = 'join',
    INVITE = 'invite',
    FEEDBACK = 'feedback',
    PERSONAL_INFORMATION = 'personal-information',
    NOTIFICATIONS = 'notifications',
    ORGANISATION_DETAILS = 'organisation-details',
    ACTIVITY_SETTINGS = 'activity-settings',
    USERS = 'users',
    BILLING = 'billing',
}

export class RouteLinkGenerator {
    public static baseUrl(organisationId?: string) {
        return organisationId ? `${organisationId}` : `${RouteName.DEFAULT_ORGANISATION_ID}`;
    }

    public static home(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.HOME}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.HOME}`;
    }

    public static contacts(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.CONTACTS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.CONTACTS}`;
    }

    public static contact(organisationId: string, contactId: string) {
        return organisationId ? `${organisationId}/${RouteName.CONTACTS}/${RouteName.CONTACT}/${contactId}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.CONTACTS}/${RouteName.CONTACT}/${contactId}`;
    }

    public static settings(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.SETTINGS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.SETTINGS}`;
    }

    public static search(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.SEARCH}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.SEARCH}`;
    }

    public static tasks(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.TASKS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.TASKS}`;
    }

    public static companies(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.COMPANIES}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.COMPANIES}`;
    }

    public static deals(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.DEALS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.DEALS}`;
    }

    public static products(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.PRODUCTS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.PRODUCTS}`;
    }

    public static broadcasts(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.BROADCASTS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.BROADCASTS}`;
    }

    public static calls(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.CALLS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.CALLS}`;
    }

    public static reports(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.REPORTS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.REPORTS}`;
    }

    public static automations(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.AUTOMATIONS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.AUTOMATIONS}`;
    }

    public static marketplace(organisationId?: string) {
        return organisationId ? `${organisationId}/${RouteName.MARKETPLACE}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.MARKETPLACE}`;
    }

    public static help(organisationId: string) {
        return organisationId ? `${organisationId}/${RouteName.HELP}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.HELP}`;
    }

    public static fields(organisationId: string) {
        return organisationId ? `${organisationId}/${RouteName.SETTINGS}/${RouteName.FIELDS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.SETTINGS}/${RouteName.FIELDS}`;
    }

    public static activitySettings(organisationId: string) {
        return organisationId ? `${organisationId}/${RouteName.SETTINGS}/${RouteName.ACTIVITY_SETTINGS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.SETTINGS}/${RouteName.ACTIVITY_SETTINGS}`;
    }

    public static personalInformation(organisationId: string) {
        return organisationId ? `${organisationId}/${RouteName.SETTINGS}/${RouteName.PERSONAL_INFORMATION}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.SETTINGS}/${RouteName.PERSONAL_INFORMATION}`;
    }

    public static organisationDetails(organisationId: string) {
        return organisationId ? `${organisationId}/${RouteName.SETTINGS}/${RouteName.ORGANISATION_DETAILS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.SETTINGS}/${RouteName.ORGANISATION_DETAILS}`;
    }

    public static users(organisationId: string) {
        return organisationId ? `${organisationId}/${RouteName.SETTINGS}/${RouteName.USERS}` : `${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.SETTINGS}/${RouteName.USERS}`;
    }

    public static authorizeApp() {
        return `${RouteName.OAUTH}/${RouteName.AUTHORIZE}`;
    }

    public static auth() {
        return `${RouteName.AUTH}`;
    }

    public static logout() {
        return `${RouteName.LOGOUT}`;
    }

    public static switchOrganisation() {
        return `${RouteName.ORGANISATIONS}/${RouteName.LIST}`;
    }

    public static createOrganisation() {
        return `${RouteName.ORGANISATIONS}/${RouteName.CREATE}`;
    }

    public static joinOrganisation() {
        return `${RouteName.ORGANISATIONS}/${RouteName.JOIN}`;
    }

    public static selectOrganisationPath() {
        return `${RouteName.ORGANISATIONS}/${RouteName.SELECT}`;
    }
}